import { api } from "../axios/axios";

// Food category on Home
export const handleGetFoodCategory = async () => {
  try {
    const { data } = await api.get("/api/food_types");
    return data;
  } catch (error) {
    console.log(error);
    throw new Error(
      error.message || "Something is wrong while fetching food category"
    );
  }
};

// All Dishes in a city (all-dishes)
// All Dishes in a city (all-dishes)
export const handleGetAllDishesOfCity = async (cityId, params = {}) => {
  try {
    const { data } = await api.get(`/api/all_dishes/${cityId}`, { params });

    // Only return dishes whose chef is active and not kitchen-offline right now
    return (data || []).filter(
      (dish) => dish?.user?.is_active === 1 && !dish?.user?.kitchen_offline,
    );
  } catch (error) {
    throw new Error(
      error.message || "Something is wrong while fetching All dishes of city"
    );
  }
};
// Categorize Dishes in a City (categorizeDishes)
export const handleGetCategorizeDishesOfCity = async (foodTypeId, cityId) => {
  try {
    const { data } = await api.get(`/api/category_menus/${foodTypeId}/${cityId}`);
    // Hide dishes whose chef's kitchen is currently offline
    return (data || []).filter((dish) => !dish?.user?.kitchen_offline);
  } catch(error){
    console.error("Error While fetching Categorize Dish\n", error)
  }
}

// Popular Dishes in a city (Home page)
export const handleGetPopularDishes = async (cityId) => {
  try {
    const { data } = await api.get(`/api/popular_dishes_with_chef/${cityId}`);

    console.log("POPULAR DISHES RESPONSE");
    console.log(data);
    console.log(data[0]);

    // Hide dishes whose chef's kitchen is currently offline
    return (data || []).filter((dish) => !dish?.user?.kitchen_offline);
  } catch (error) {
    throw new Error(
      error.message || "Something is wrong while fetching Popular dishes "
    );
  }
};

// Popular Chef with dishes (Home page - Most loved chef)
export const handleGetPopularChefWithDishes = async (cityId) => {
  try {
    const { data } = await api.get(`/api/popular_chef_with_dishes/${cityId}`);
    // Hide chefs whose kitchen is currently offline
    return (data || []).filter((chef) => !chef?.kitchen_offline);
  } catch (error) {
    throw new Error(
      error.message || "Something is wrong while fetching Popular dishes "
    );
  }
}

// Get All chefs in a city (all-chef page)
export const handleGetAllChefs = async (cityId, params = {}) => {
  try {
    const { data } = await api.get(`/api/all_chef/${cityId}`, { params });

    // Only return active chefs whose kitchen is not currently offline
    return (data || []).filter(
      (chef) => chef?.is_active === 1 && !chef?.kitchen_offline,
    );
  } catch (error) {
    throw new Error(
      error.message || "Something is wrong while fetching Chefs "
    );
  }
};



// Get Chef with dishes (Chef-detail page)
export const handleGetChefWithDishes = async (chefId, cityId) => {
  try {
    const { data } = await api.get(`/api/chef_with_dishes/${chefId}/${cityId}`);
    // Hide dishes while the chef's kitchen is offline
    return data?.kitchen_offline ? { ...data, menus: [] } : data;
  } catch (error) {
    throw new Error(
      error.message || "Something is wrong while fetching Chef with dishes "
    );
  }
}


// Get Single Dish (dish-detail-single page)
export const handleGetSingleDish = async ( dishId) => {
  try {
    const { data } = await api.get(`/api/single_menu/${dishId}`);
    return data;
  } catch (error) {
    console.log(error);
    throw new Error(
      error.message || "Something is wrong while Fetching Dishes"
    );
  }
}

// Get a chef's Kitchen Offline windows (public — used on checkout)
export const handleGetChefOfflineWindows = async (chefId) => {
  try {
    const { data } = await api.get(`/api/chef/${chefId}/kitchen-offline`);
    return data;
  } catch (error) {
    console.log(error);
    return [];
  }
};